
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { SelecaoComFiltro } from "app/components/selecao-com-filtro/SelecaoComFiltro";
import { Separador } from "app/components/separador/Separador";
import { CepPorEndereco, Classificacao } from "app/types/comissoes/DadosBasicosIndicadores";
import { ICidade } from "app/types/ICidade";
import { IEndereco } from "app/types/IEndereco";
import { IEstado } from "app/types/IEstado";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { Bairro } from "../../../../types/NovoEndereco";
import { InputCep } from "../../../inputs/InputCep";

const estiloBotoes = require('../../../../estilos/botoes.module.scss').default
const estilosInputs = require("../../../../estilos/inputs.module.scss").default;

export type NovoEnderecoProps = {
  bairros: Bairro[];
  estados: IEstado[];
  cidades: ICidade[];
  opcoesTipo: Classificacao[];
  utilizarBairrosPreCadastrados: boolean
  numeroEBairroObrigatorio: boolean
  endereco: IEndereco
  dadosModalEndereco: PagedMessageResponse<CepPorEndereco>;
  onErrorValidacao: (erroNovoEndereco: FormikErrors<IEndereco>) => void
  onAdicionar: (endereco: IEndereco) => void;
  onPesquisarCep: (cep: string) => void;
  onListarBairros: (bairro: string) => void;
  onListarCidadesPorEstado: (codigoEstado: number) => void;
  pesquisaPorEndereco: () => void;
  atualzaDadosASerSalvos: (endereco: IEndereco) => void
};

export const NovoEndereco = (props: NovoEnderecoProps) => {
  const [validado, setValidado] = useState(false);
  const [carregandoBairro, setCarregadoBairro] = useState(false)
  const [comboBairro, setComboBairro] = useState(props.endereco?.Bairro ?? "")

  const formik = useFormik({
    initialValues: { ...props.endereco },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
    validate: (values) => {
      const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`;
      return R.pickBy((val) => globalMU.isNotNullOrEmpty(val), {
        Classificacoes: values.Classificacoes?.length <= 0 && !values.DescricaoClassificacoes ? mensagemObrigatorio("Tipo") : undefined,
        Cep: !values.Cep ? mensagemObrigatorio("Cep") : undefined,
        Numero: !values.Numero && props.numeroEBairroObrigatorio ? mensagemObrigatorio("Numero") : undefined,
        Logradouro: !values.Logradouro ? mensagemObrigatorio("Logradouro") : undefined,
        Bairro: !values.Bairro && props.numeroEBairroObrigatorio ? mensagemObrigatorio("Bairro") : undefined,
        CodigoEstado: !values.CodigoEstado && !values.SiglaUf ? mensagemObrigatorio("UF") : undefined,
        CodigoCidade: !values.CodigoCidade && !values.NomeCidade ? mensagemObrigatorio("Cidade") : undefined,
      } as FormikErrors<IEndereco>);
    },
  });

  useEffect(() => {
    props.atualzaDadosASerSalvos(formik.values)
  }, [formik.values])

  useEffect(() => {
    setCarregadoBairro(false)
  }, [props.bairros])

  useEffect(() => {
    setComboBairro(props.endereco?.Bairro)
  }, [props.endereco?.Bairro])

  const tipo = <>
    <label className="_w-[160px] _text-right _font-normal">Tipo <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p></label>
    <div>
      <select
        className={`_w-[100px] _h-[112px] ${validado && formik.errors.Classificacoes != undefined && estilosInputs.inputComErro}`}
        multiple={true}
        autoFocus
        id="NovoEnderecoComissoes_Tipo"
        name="Classificacoes"
        value={(formik.values.Classificacoes?.map(x => x.toString())) ?? ""}
        size={7}
        onChange={(e) => {
          const disponibilidadesSelecionadas = Array.from(e.target.selectedOptions)?.map((o) => o.value);
          const nomeDisponibilidadesSelecionadas = props.opcoesTipo.filter((tipo) => disponibilidadesSelecionadas.includes(tipo.Codigo.toString())).map(tipo => tipo.Nome).toString()
          formik.setFieldValue("Classificacoes", disponibilidadesSelecionadas);
          formik.setFieldValue("DescricaoClassificacoes", nomeDisponibilidadesSelecionadas);
        }}
      >
        {props.opcoesTipo?.map((tipo) => (
          <option key={tipo.Codigo} value={tipo.Codigo}>
            {tipo.Nome}
          </option>
        ))}
      </select>
    </div>
  </>

  const cep = <>
    <label className="_w-[160px] _text-right _font-normal">
      CEP <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <div>
      <InputCep
        className={`_w-[100px] ${validado && formik.errors.Cep != undefined && estilosInputs.inputComErro}`}
        cep={formik.values.Cep}
        id="NovoEnderecoComissoes_Cep"
        key="NovoEnderecoComissoes_Cep"
        onCepModificado={(cep) => {
          formik.setFieldValue("Cep", cep);
          cep != null && props.onPesquisarCep(cep)
        }}
        emitirComMascara
      />
    </div>
  </>

  const buttonPesquisaCep = <button
    className={`no-global-button ${estiloBotoes.botaoPrimario}`}
    id="NovoOrcamentoComissoes_PesquisarCep"
    disabled={formik.values.Cep?.length > 0}
    onClick={() => {
      props.pesquisaPorEndereco()
    }}
  >
    Pesquisar CEP
  </button>

  const logradouro = <>
    <label className="_w-[160px] _text-right _font-normal">
      Logradouro<p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <div>
      <input
        name="Logradouro"
        type="text"
        className={`_w-[280px] _mr-1 ${validado && formik.errors.Logradouro != undefined && estilosInputs.inputComErro}`}
        style={{ marginRight:"5px"}}
        maxLength={254}
        value={(formik.values.Logradouro) ?? ""}
        onChange={formik.handleChange}
      />

      {buttonPesquisaCep}

    </div>
  </>

  const numero = <>
    <label className="_w-[160px] _text-right _font-normal">
      Número {props.numeroEBairroObrigatorio && <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>}
    </label>
    <div>
      <input
        name="Numero"
        type="text"
        className={`_w-[100px] ${validado && formik.errors.Numero != undefined && estilosInputs.inputComErro}`}
        maxLength={30}
        value={(formik.values.Numero) ?? ""}
        onChange={formik.handleChange}
      />
    </div>
  </>

  const complemento = <>
    <label className="_w-[160px] _text-right _font-normal">Complemento</label>
    <div>
      <input
        name="Complemento"
        type="text"
        className="_w-[280px]"
        maxLength={254}
        value={(formik.values.Complemento) ?? ""}
        onChange={formik.handleChange}
      />
    </div></>


  const bairro = <>
    <label title="Utilizar no Orçamento bairros pré-cadastrados = Não" className="_w-[160px] _text-right _font-normal">
      Bairro {props.numeroEBairroObrigatorio && <p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>}
    </label>


    {props.utilizarBairrosPreCadastrados ?
      <SelecaoComFiltro
        classNameInput={`_w-[280px] ${validado && formik.errors.Bairro != undefined && estilosInputs.inputComErro}`}
        itens={carregandoBairro ? [{ chave: "", valor: "Buscando..." }] : (props.bairros ?? []).map(bairro => ({
          chave: bairro.Codigo.toString(),
          valor: bairro.Nome
        }))}
        onValorModificado={(bairro) => (setCarregadoBairro(true), formik.setFieldValue("Bairro", ""), setComboBairro(bairro), props.onListarBairros(bairro))}
        onItemSelecionado={item => {
          formik.setFieldValue("Bairro", (props?.bairros ?? []).find(b => b.Codigo.toString() == item.chave).Nome)
          setComboBairro((props?.bairros ?? []).find(b => b.Codigo.toString() == item.chave).Nome)
        }}
        itemSelecionado={{
          chave: (props?.bairros ?? []).find(b => b.Nome.toString() == formik.values.Bairro)?.Codigo.toString(),
          valor: comboBairro
        }}
        filtroManual={true}
        placeholder="Digite 1 ou mais caracteres"
      />
      :
      <input
        className={`_w-[280px] ${validado && formik.errors.Bairro != undefined && estilosInputs.inputComErro}`}
        name="Bairro"
        value={(formik.values?.Bairro) ?? ""}
        onChange={formik.handleChange}
      />
    }
  </>

  const uf = <>
    <label className="_w-[160px] _text-right _font-normal">
      U.F.<p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>

    <div>
      <select
        defaultValue="Selecionar"
        className={`_w-[60px] ${validado && formik.errors.CodigoEstado != undefined && estilosInputs.inputComErro}`}
        multiple={false}
        value={(formik.values?.CodigoEstado) ?? ""}
        onChange={(e) => {
          formik.setFieldValue("CodigoEstado", e.target.value);
          formik.setFieldValue("SiglaUf", props.estados.find(estado => estado.Codigo.toString() == e.target.value).Nome);
          props.onListarCidadesPorEstado(Number(e.target.value));
        }}
      >
        <option value="">Selecione</option>
        {props.estados?.map((value) => (
          <option
            key={value.Codigo}
            selected={
              props.endereco != null ?
                props.endereco.Estado != null ? props.endereco.Estado.Codigo == value.Codigo : false
                : false
            }
            value={value.Codigo}
          >
            {value.Sigla}
          </option>
        ))}
      </select>
    </div>
  </>


  const cidade = <>
    <label className="_w-[160px] _text-right _font-normal">
      Cidade<p className="_inline-flex _ml-[5px] _mb-0 _font-bold _text-[#f25713]">*</p>
    </label>
    <div>
      <select
        multiple={false}
        value={(formik.values?.CodigoCidade) ?? ""}
        className={`_w-[280px] ${validado && formik.errors.CodigoCidade != undefined && estilosInputs.inputComErro}`}
        onChange={(e) => {
          formik.setFieldValue("CodigoCidade", e.target.value)
          formik.setFieldValue("NomeCidade", props.cidades.find(cidade => cidade.Codigo.toString() == e.target.value).Nome)
        }}
      >
        <option value="">Selecione</option>
        {props.cidades != null && (
          props.cidades?.map((value) => (
            <option
              key={value.Codigo}
              selected={props.endereco != null ?
                props.endereco.Cidade != null ? props.endereco.Cidade.Codigo == value.Codigo : false
                : false
              }
              value={value.Codigo}
            >
              {value.Nome}
            </option> 
          )))}
      </select>
    </div>
  </>


  const referencia = <>
    <label className="_w-[160px] _text-right _font-normal">Referência </label>
    <div>
      <input
        name="Referencia"
        type="text"
        className="_w-[280px]"
        maxLength={254}
        value={(formik.values.Referencia) ?? ""}
        onChange={formik.handleChange}
      />
    </div>
  </>

  const buttonAdicionar = <button
    className={`no-global-button _mr-24 ${estiloBotoes.botaoPrimario}`}
    onClick={async () => {
      const erros = await formik.validateForm(formik.values)
      if (Object.keys(erros).length == 0) {
        props.onAdicionar(formik.values)
      } else {
        props.onErrorValidacao(erros)
      }
      setValidado(true);
    }}
  >
    {props.endereco == null ? "Adicionar" : "Alterar"}
  </button>

  return (
    <>
      <Separador />

      <div className={`_grid _grid-cols-[min-content_auto] _gap-y-2 _gap-x-3 _float-left _my-2`}>
        {tipo}

        {cep}

        {logradouro}

        {numero}

        {complemento}

        {bairro}

        {uf}

        {cidade}

        {referencia}

        {buttonAdicionar}
      
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
